
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getFeed",
      resolverType: "query",
      routePath: "/getFeed",
      httpMethod: "POST",
    });
  